import React from "react";
import { Search, X, ChevronDown } from "lucide-react";



function FitrosLocalesGiftCardComponent({ nameCedula, handleNameCedula }) {





    return (
        <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-200 mb-6">
            <div className="relative w-full">

                {/* Buscar local */}
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Buscar local
                    </label>
                    <div className="relative flex items-center">
                        <Search size={16} className="absolute left-3 text-gray-400 pointer-events-none" />
                        <input
                            type="text"
                            value={nameCedula}
                            onChange={(e) => handleNameCedula(e.target.value)}
                            autoCapitalize="none"
                            autoCorrect="off"
                            placeholder="Razón social, RUC o nombre de fantasía"
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] py-2 pl-9 pr-9 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                        />
                        {nameCedula && (
                            <button
                                type="button"
                                onClick={() => handleNameCedula("")}
                                className="absolute right-3 text-gray-400 hover:text-gray-600 transition-colors"
                            >
                                <X size={15} />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FitrosLocalesGiftCardComponent;